import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Table, Empty } from 'antd';
import moment from 'moment';
import './styles.css';
import auth from '../../../common/utility/auth';
import TextArea from 'antd/lib/input/TextArea';

import { FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';
import {
    LOGISTICA_PRODUCTOS_CON_LOTE, SERIE_POR_PRODUCTO
} from '../../../common/types/parametroType';

const InputGroup = Input.Group;
const { TabPane } = Tabs;
const { Option } = Select;
class FormModalVer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('arrDetalle', { initialValue: [] });

        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });

        const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
        const mostrarSaniProd = mostrarLoteProducto;
        const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;

        return (
            <Modal
                title="Ver Ingreso"
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Ok"}
                onCancel={this.handleCancel}
                onOk={this.handleCancel}
                width="1100px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('idOrdenCompra', { initialValue: this.props.formValues.idOrdenCompra })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                //onChange={(moment, value) => this.props.onChange('fechaStr', value)}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('nombreMoneda', {
                                    initialValue: this.props.formValues.nombreMoneda
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-9 form-group">
                            <Form.Item label="Entidad">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('documentoEntidad', {
                                            initialValue: this.props.formValues.documentoEntidad
                                        })(
                                            <Input readOnly={true} />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('razonSocialEntidad', {
                                            initialValue: this.props.formValues.razonSocialEntidad
                                        })(
                                            <Input readOnly={true} />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Concepto">
                                {getFieldDecorator('idConcepto', {
                                    initialValue: this.props.formValues.nombreConcepto
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>


                    </div>

                    <div className="row">

                        <div className="col-md-3 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.nombreEstablecimiento
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Tipo Almacén">
                                {getFieldDecorator('idTipoAlmacen', {
                                    initialValue: this.props.formValues.idTipoAlmacen ?
                                        { key: this.props.formValues.idTipoAlmacen } : undefined

                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"                        >
                                        {this.props.formValues.TipoAlmacen.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                        <div className="col-md-3 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacen', {
                                    initialValue: this.props.formValues.nombreAlmacen
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.nombreProyecto
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <Table
                                        className={'table-producto'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        // pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        rowKey={record => record.idProducto}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='No se han agregado productos'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Código',
                                                dataIndex: 'codigo',
                                                key: 'codigo',
                                                align: 'center',
                                                width: 80,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Nombre',
                                                dataIndex: 'nombre',
                                                key: 'nombre',
                                                width: 300,
                                                ellipsis: true,
                                                render: (value, row) => (

                                                    <div >
                                                        <TextArea
                                                            placeholder="Ingresar Nro Cuenta Bancaria"
                                                            rows={value.length < 25 ? 1 : 3}
                                                            value={value}
                                                            autoComplete="off"
                                                        />
                                                    </div>

                                                )
                                            },
                                            {
                                                title: (seriePorProducto) ? 'Series' : '',
                                                dataIndex: 'detalleSeries',
                                                key: 'detalleSeries',
                                                align: 'left',
                                                width: (seriePorProducto) ? 90 : 0,
                                                ellipsis: true
                                            },

                                            {
                                                title: 'Unidad Medida',
                                                dataIndex: 'nombreUnidadMedida',
                                                key: 'nombreUnidadMedida',
                                                width: 120,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Unidad Medida',
                                                dataIndex: 'nombreUnidadMedida',
                                                key: 'nombreUnidadMedida',
                                                width: 120,
                                                ellipsis: true
                                            },
                                            (mostrarSaniProd ? {
                                                title: 'Fecha Produccion',
                                                dataIndex: 'fechaProduccion',
                                                key: 'fechaProduccion',
                                                width: 120,
                                                ellipsis: true
                                            } : {}),
                                            (mostrarLoteProducto ? {
                                                title: 'Fecha Vencimiento',
                                                dataIndex: 'fechaVencimiento',
                                                key: 'fechaVencimiento',
                                                width: 120,
                                                ellipsis: true
                                            } : {})
                                            ,
                                            (mostrarSaniProd ? {
                                                title: 'Numero Registro Sanitario',
                                                dataIndex: 'numeroRegistroSanitario',
                                                key: 'numeroRegistroSanitario',
                                                width: 120,
                                                ellipsis: true
                                            } : {})
                                            ,


                                            (mostrarLoteProducto ?
                                                {
                                                    title: 'Lote',
                                                    dataIndex: 'lote',
                                                    key: 'lote',
                                                    width: 120,
                                                    ellipsis: true
                                                } : {})
                                            ,
                                            {
                                                title: 'Tipo Impuesto',
                                                dataIndex: 'tipoImpuesto',
                                                key: 'tipoImpuesto',
                                                width: 180,

                                            },
                                            {
                                                title: 'Valor Unitario',
                                                dataIndex: 'precioUnitarioSinIGV',
                                                key: 'precioUnitarioSinIGV',
                                                align: 'center',
                                                width: 90
                                            },
                                            {
                                                title: 'Precio Unitario',
                                                dataIndex: 'precioUnitario',
                                                key: 'precioUnitario',
                                                align: 'center',
                                                width: 90
                                            },

                                            {
                                                title: 'Cantidad',
                                                dataIndex: 'cantidad',
                                                key: 'cantidad',
                                                align: 'center',
                                                width: 90
                                            },
                                            {
                                                title: 'Sub Total',
                                                dataIndex: 'subTotal',
                                                key: 'subTotal',
                                                align: 'center',
                                                width: 90
                                            },
                                            {
                                                title: 'IGV',
                                                dataIndex: 'igv',
                                                key: 'igv',
                                                align: 'center',
                                                width: 80
                                            },
                                            {
                                                title: 'Total',
                                                dataIndex: 'total',
                                                key: 'total',
                                                fixed: 'right',
                                                align: 'center',
                                                width: 90
                                            }
                                        ]}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <Table
                                        className={'table-referencia'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        rowKey={record => record.identifier}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='Pulse el botón "+ Agregar".'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Tipo Comprobante',
                                                dataIndex: 'nombreTipoComprobante',
                                                key: 'nombreTipoComprobante',
                                                align: 'center',
                                                width: 350,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Serie',
                                                dataIndex: 'serie',
                                                key: 'serie',
                                                width: 100,
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Documento',
                                                dataIndex: 'documento',
                                                key: 'documento',
                                                width: 120,
                                                ellipsis: true
                                            }
                                        ]}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-md-6"}>

                        </div>
                        <div className="col-md-3 form-group">

                        </div>
                        <div className="col-md-3 pt-10">

                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>Sub Total</label>
                                    <div>{this.props.formValues.sumaSubTotal.toFixed(2)}</div>
                                </div>
                            </div>
                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>IGV</label>
                                    <div>{this.props.formValues.sumaIgv.toFixed(2)}</div>
                                </div>
                            </div>
                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>Total</label>
                                    <div>{this.props.formValues.sumaTotal.toFixed(2)}</div>
                                </div>
                            </div>

                        </div>
                    </div>

                </Form>
            </Modal>
        )
    }
}

export default Form.create()(FormModalVer)